export const osm = {
    maptiler: {
        url: `https://api.maptiler.com/maps/outdoor-v2/256/{z}/{x}/{y}.png?key=${process.env.REACT_APP_TICINO_MAP_TILER_KEY}`,
        attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
    }
}